<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post20-stratotanker-diagram-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post20-stratotanker-diagram-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.55474269127811;"
    data-aspect-ratio="0.555"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post20-stratotanker-diagram-xs-img"
      class="g-post20-stratotanker-diagram-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-diagram-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs"
      style="top:9.4138%;left:31.0047%;margin-left:-23.6364%;width:47.2727%;"
    >
      <p class="g-pstyle1">
        Often among the first tanks used in normal consumption sequence.
      </p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.5245%;margin-top:-8.6px;left:85.0178%;width:56px;"
    >
      <p class="g-pstyle2">Boom</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.3995%;margin-top:-16.6px;right:42.3753%;width:78px;"
    >
      <p class="g-pstyle3">Upper</p>
      <p class="g-pstyle3">deck tank</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.6711%;margin-top:-8.6px;left:67.2001%;width:100px;"
    >
      <p class="g-pstyle2">Aft body tank</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.8694%;margin-top:-24.6px;left:81.3915%;width:67px;"
    >
      <p class="g-pstyle2">Wing</p>
      <p class="g-pstyle2">reserve</p>
      <p class="g-pstyle2">tanks</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs"
      style="top:68.7545%;right:67.9149%;width:23.6364%;"
    >
      <p class="g-pstyle4">Forward body tank</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.5591%;margin-top:-8.6px;left:55.9616%;margin-left:-43px;width:86px;"
    >
      <p class="g-pstyle5">Main tanks</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs"
      style="top:74.8062%;right:68.0111%;width:29.697%;"
    >
      <p class="g-pstyle6">Used to carry ballast</p>
      <p class="g-pstyle6">fuel to correct</p>
      <p class="g-pstyle6">center‑of‑gravity issues.</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.5936%;margin-top:-9.6px;left:56.1296%;margin-left:-46.5px;width:93px;"
    >
      <p class="g-pstyle7">600 lb each</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:88.6884%;margin-top:-8.6px;left:60.9277%;margin-left:-48px;width:96px;"
    >
      <p class="g-pstyle5">TOTAL FUEL</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:91.8824%;margin-top:-8.6px;left:60.9677%;margin-left:-45.5px;width:91px;"
    >
      <p class="g-pstyle8">200,000 lb</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:92.0505%;margin-top:-9.6px;left:20.9857%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle7">3,500 lb</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.6624%;margin-top:-6.6px;left:31.0497%;margin-left:-60.5px;width:121px;"
    >
      <p class="g-pstyle0">Center wing tank</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post20-stratotanker-diagram-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.85732961379345;"
    data-aspect-ratio="0.857"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post20-stratotanker-diagram-sm-img"
      class="g-post20-stratotanker-diagram-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-diagram-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs"
      style="top:7.7328%;left:34.093%;margin-left:-15.2941%;width:30.5882%;"
    >
      <p class="g-pstyle1">
        Often among the first tanks used in normal consumption sequence.
      </p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:20.6063%;margin-top:-8.6px;left:82.7872%;width:56px;"
    >
      <p class="g-pstyle2">Boom</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.6667%;margin-top:-16.6px;right:42.4927%;width:78px;"
    >
      <p class="g-pstyle3">Upper</p>
      <p class="g-pstyle3">deck tank</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.309%;margin-top:-8.6px;left:66.7833%;width:100px;"
    >
      <p class="g-pstyle2">Aft body tank</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.2142%;margin-top:-24.6px;left:82.3539%;width:67px;"
    >
      <p class="g-pstyle2">Wing</p>
      <p class="g-pstyle2">reserve</p>
      <p class="g-pstyle2">tanks</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.3823%;margin-top:-6.6px;right:67.4247%;width:131px;"
    >
      <p class="g-pstyle4">Forward body tank</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.0547%;margin-top:-8.6px;left:56.6948%;margin-left:-43px;width:86px;"
    >
      <p class="g-pstyle5">Main tanks</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.4341%;margin-top:-24.6px;right:67.3405%;width:158px;"
    >
      <p class="g-pstyle6">Used to carry ballast</p>
      <p class="g-pstyle6">fuel to correct</p>
      <p class="g-pstyle6">center‑of‑gravity issues.</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.0892%;margin-top:-8.6px;left:56.8036%;margin-left:-46.5px;width:93px;"
    >
      <p class="g-pstyle7">600 lb each</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:86.5031%;margin-top:-9.6px;left:25.57%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle8">3,500 lb</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:88.6884%;margin-top:-8.6px;left:58.9828%;margin-left:-48px;width:96px;"
    >
      <p class="g-pstyle5">TOTAL FUEL</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:91.8824%;margin-top:-8.6px;left:59.0085%;margin-left:-45.5px;width:91px;"
    >
      <p class="g-pstyle7">200,000 lb</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.1494%;margin-top:-6.6px;left:34.122%;margin-left:-60.5px;width:121px;"
    >
      <p class="g-pstyle0">Center wing tank</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post20-stratotanker-diagram-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.89737086322207;"
    data-aspect-ratio="0.897"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post20-stratotanker-diagram-md-img"
      class="g-post20-stratotanker-diagram-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-diagram-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs"
      style="top:7.4781%;right:71.5338%;width:26.3636%;"
    >
      <p class="g-pstyle1">
        Often among the first tanks used in normal consumption sequence.
      </p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:17.2219%;margin-top:-9.7px;left:86.4918%;width:61px;"
    >
      <p class="g-pstyle2">Boom</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:25.9124%;margin-top:-8.6px;right:41.7193%;width:118px;"
    >
      <p class="g-pstyle3">Upper deck tank</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.1036%;margin-top:-8.7px;left:67.905%;width:111px;"
    >
      <p class="g-pstyle4">Aft body tank</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.5485%;margin-top:-24.6px;left:84.5203%;width:67px;"
    >
      <p class="g-pstyle5">Wing</p>
      <p class="g-pstyle5">reserve</p>
      <p class="g-pstyle5">tanks</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.6475%;margin-top:-6.7px;left:57.4768%;margin-left:-47.5px;width:95px;"
    >
      <p class="g-pstyle6">Main tanks</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.6475%;margin-top:-6.7px;right:71.2176%;width:147px;"
    >
      <p class="g-pstyle0">Forward body tank</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs"
      style="top:75.1888%;right:71.3044%;width:23.9394%;"
    >
      <p class="g-pstyle1">
        Used to carry ballast fuel to correct center‑of‑gravity issues.
      </p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.8994%;margin-top:-9.6px;left:57.5734%;margin-left:-46.5px;width:93px;"
    >
      <p class="g-pstyle7">600 lb each</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:85.8731%;margin-top:-9.6px;left:23.2744%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle7">3,500 lb</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.8274%;margin-top:-9.7px;left:58.6236%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle8">TOTAL FUEL</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:92.4107%;margin-top:-9.7px;left:58.6248%;margin-left:-50.5px;width:101px;"
    >
      <p class="g-pstyle9">200,000 lb</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.9368%;margin-top:-6.7px;right:71.5835%;width:135px;"
    >
      <p class="g-pstyle0">Center wing tank</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post20-stratotanker-diagram-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 1.5;"
    data-aspect-ratio="1.5"
    data-min-width="930"
  >
    <div
      id="g-post20-stratotanker-diagram-lg-img"
      class="g-post20-stratotanker-diagram-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-diagram-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.3007%;margin-top:-6.7px;right:75.9254%;width:148px;"
    >
      <p class="g-pstyle1">Wing reserve tanks</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.1716%;margin-top:-9.7px;left:48.2565%;width:131px;"
    >
      <p class="g-pstyle0">Upper deck tank</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.6878%;margin-top:-6.7px;left:66.2149%;width:111px;"
    >
      <p class="g-pstyle2">Aft body tank</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:54.6232%;margin-top:-6.7px;right:79.0104%;width:135px;"
    >
      <p class="g-pstyle1">Center wing tank</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-text g-aiAbs"
      style="top:56.4516%;right:78.9751%;width:18.7097%;"
    >
      <p class="g-pstyle3">
        Often among the first tanks used in normal consumption sequence.
      </p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.6232%;margin-top:-6.7px;right:60.5575%;width:147px;"
    >
      <p class="g-pstyle1">Forward body tank</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.6232%;margin-top:-6.7px;right:37.0157%;width:95px;"
    >
      <p class="g-pstyle1">Main tanks</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.0748%;margin-top:-9.7px;left:87.6761%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle4">TOTAL FUEL</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-text g-aiAbs"
      style="top:81.6129%;right:60.5249%;width:25.4839%;"
    >
      <p class="g-pstyle3">
        Used to carry ballast fuel to correct center‑of‑gravity issues.
      </p>
    </div>
    <div
      id="g-ai3-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.6421%;margin-top:-9.6px;left:58.6194%;margin-left:-46.5px;width:93px;"
    >
      <p class="g-pstyle5">600 lb each</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:84.3007%;margin-top:-9.7px;left:87.6769%;margin-left:-50.5px;width:101px;"
    >
      <p class="g-pstyle6">200,000 lb</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:90.255%;margin-top:-9.6px;left:35.5335%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle5">3,500 lb</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.0103%;margin-top:-9.7px;left:80.1981%;width:61px;"
    >
      <p class="g-pstyle0">Boom</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-19 10:46 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-19 10:46 -->
<!-- ai file: post20-stratotanker-diagram.ai -->
<style lang="scss">
  #g-post20-stratotanker-diagram-box {
    container-type: inline-size;
    container-name: g-post20-stratotanker-diagram-box;
  }
  #g-post20-stratotanker-diagram-box,
  #g-post20-stratotanker-diagram-box .g-artboard {
    margin: 0 auto;
  }
  #g-post20-stratotanker-diagram-box p {
    margin: 0;
  }
  #g-post20-stratotanker-diagram-box .g-aiAbs {
    position: absolute;
  }
  #g-post20-stratotanker-diagram-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post20-stratotanker-diagram-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post20-stratotanker-diagram-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-stratotanker-diagram-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-stratotanker-diagram-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post20-stratotanker-diagram-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post20-stratotanker-diagram-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post20-stratotanker-diagram-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-post20-stratotanker-diagram-lg {
        display: block !important;
      }
    }
  }
  #g-post20-stratotanker-diagram-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-diagram-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-diagram-xs .g-pstyle0 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-xs .g-pstyle1 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-diagram-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-diagram-xs .g-pstyle4 {
    font-weight: 400;
    line-height: 16px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-diagram-xs .g-pstyle5 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-xs .g-pstyle6 {
    font-weight: 300;
    line-height: 16px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-diagram-xs .g-pstyle7 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-xs .g-pstyle8 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-diagram-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-diagram-sm .g-pstyle0 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-sm .g-pstyle1 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-diagram-sm .g-pstyle3 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-diagram-sm .g-pstyle4 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-diagram-sm .g-pstyle5 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-sm .g-pstyle6 {
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-diagram-sm .g-pstyle7 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-sm .g-pstyle8 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-diagram-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-diagram-md .g-pstyle0 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-diagram-md .g-pstyle1 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-diagram-md .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-diagram-md .g-pstyle3 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: right;
  }
  #g-post20-stratotanker-diagram-md .g-pstyle4 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-diagram-md .g-pstyle5 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
  }
  #g-post20-stratotanker-diagram-md .g-pstyle6 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-md .g-pstyle7 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-md .g-pstyle8 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-md .g-pstyle9 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-diagram-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-diagram-lg .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-diagram-lg .g-pstyle1 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-diagram-lg .g-pstyle2 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-diagram-lg .g-pstyle3 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-diagram-lg .g-pstyle4 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-lg .g-pstyle5 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
  }
  #g-post20-stratotanker-diagram-lg .g-pstyle6 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }

  /* Custom CSS */
</style>
